module.exports = __webpack_public_path__ + "/assets/img/f02819c54797897f84a3a9e87cd484ea.svg";